import type { LabsGqlRemoveOrderHoldMutationVariables } from '@orthly/graphql-operations';
import { useRemoveOrderHoldMutation } from '@orthly/graphql-react';
import { useChangeSubmissionFn } from '@orthly/ui';

type RemoveOrderHoldVars = LabsGqlRemoveOrderHoldMutationVariables['data'];

export const useRemoveOrderHold = (refetch: () => void) => {
    const [submitRemoveHoldMtn] = useRemoveOrderHoldMutation();
    const removeHoldMtnSubmitter = (data: RemoveOrderHoldVars) => submitRemoveHoldMtn({ variables: { data } });

    return useChangeSubmissionFn<any, [RemoveOrderHoldVars]>(removeHoldMtnSubmitter, {
        successMessage: () => ['The order has successfully been resumed. No further action is required.'],
        onSuccess: async () => {
            refetch();
        },
    });
};
